import { render, staticRenderFns } from "./localized-date.vue?vue&type=template&id=3304c519&scoped=true&"
import script from "./localized-date.vue?vue&type=script&lang=js&"
export * from "./localized-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3304c519",
  null
  
)

export default component.exports